import { type PlatformAdapter, type PlatformConfig, mergePlatformConfig } from '@cv-builder/core'
import { createMockAuthAdapter } from './auth'
import { createLocalStorageAdapter } from './storage'

export interface LocalAdapterOptions {
  /** Custom platform config overrides */
  config?: Partial<PlatformConfig>
  /** PDF service URL for export functionality */
  pdfServiceUrl?: string
}

/**
 * Create a local adapter for demo/development
 * Uses localStorage for persistence and mock auth
 */
export function createLocalAdapter(options: LocalAdapterOptions = {}): PlatformAdapter {
  const pdfServiceUrl = options.pdfServiceUrl || 'http://localhost:3100'

  const defaultConfig: PlatformConfig = {
    platform: 'demo',
    locale: {
      defaultUiLocale: 'da-DK',
      defaultCvLocale: 'da-DK',
      supportedLocales: ['da-DK', 'en-US'],
    },
    templates: [
      {
        id: 'classic',
        name: 'Klassisk',
        description: 'Et rent og professionelt layout',
        previewUrl: '/templates/classic.png',
      },
      {
        id: 'modern',
        name: 'Moderne',
        description: 'Nutidigt design med accentfarver',
        previewUrl: '/templates/modern.png',
      },
      {
        id: 'minimal',
        name: 'Minimal',
        description: 'Enkelt og elegant',
        previewUrl: '/templates/minimal.png',
      },
      {
        id: 'sidebar-left',
        name: 'Sidebar venstre',
        description: 'Foto og kompetencer i venstre side',
        previewUrl: '/templates/sidebar-left.png',
      },
      {
        id: 'sidebar-right',
        name: 'Sidebar højre',
        description: 'Foto og kompetencer i højre side',
        previewUrl: '/templates/sidebar-right.png',
      },
    ],
    features: {
      photoUpload: true,
      pdfExport: true, // Now available via pdf-service
      multipleCVs: true,
      customSections: true,
      aiAssist: false,
    },
  }

  return {
    storage: createLocalStorageAdapter({ pdfServiceUrl }),
    auth: createMockAuthAdapter(),
    config: mergePlatformConfig(defaultConfig, options.config),
  }
}

export { createLocalStorageAdapter } from './storage'
export { createMockAuthAdapter } from './auth'
export {
  sampleCV,
  danishSampleCV,
  createSampleCV,
  createDanishSampleCV,
  createEmptyCV,
} from './sample-data'
